import React, { useState, useEffect } from "react";
import {
  Layout,
  Space,
  Card,
  Row,
  Col,
  Button,
  DatePicker,
  Form,
  Select,
  Table,
  Tag,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStates } from "../features/statecity/statecitySlice";
import {
  getWeeklyAttendance,
  getAttendance,
  resetState,
} from "../features/attendance/attendanceSlice";
import { getUsers } from "../features/cutomers/customerSlice";
import { toast } from "react-toastify";
import CustomerPopupModal from "../components/CustomerPopupModal";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import { ClockCircleOutlined, ExportOutlined } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import moment from "moment";

const { Content } = Layout;
const { Option } = Select;

const columns = [
  {
    title: "S. No",
    dataIndex: "sno",
    key: "sno",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Punch In",
    dataIndex: "punchIn",
    key: "punchIn",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Production hour",
    dataIndex: "production_hour",
    key: "production_hour",
  },
  {
    title: "Device Info",
    dataIndex: "device_info",
    key: "device_info",
  },
];

const Attendance = () => {
  const [vcData, setvcData] = useState([]);
  const [vtData, setvtData] = useState([]);
  const navigate = useNavigate();
  const [selectedVC, setselectedVC] = useState("");
  const [selectedVT, setselectedVT] = useState("");
  const [attendanceData, setAttendanceData] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [opens, setOpens] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const location = useLocation();
  const getCustomerId = location.pathname.split("/")[3];
  const [dateRange, setDateRange] = useState([null, null]); // State for date range

  const [form] = Form.useForm();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getUsers());
    dispatch(getStates());
    dispatch(getAttendance(getCustomerId));
  }, [dispatch]);

  const goBack = () => {
    navigate(-1);
  };

  const statelistState = useSelector((state) => state.statecity.statelist);

  const vclistState = useSelector((state) => state.customer.customers);

  const newAttendance = useSelector((state) => state.attendance.attendances);

  const newAllAttendance = useSelector((state) => state.attendance.attendancesall);

  const openModal = (customerId) => {
    setOpens(true);
    setCustomerId(customerId);
  };

  const closeModal = () => {
    setOpens(false);
  };

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setselectedVC(value);
  };

  const handleVcChange = (value) => {
    const vtfilterData = vclistState.filter(
      (customer) => customer.vcuser_id === value
    );
    setvtData(vtfilterData);
    setselectedVT(value);
  };

  const handleSubmit = (values) => {
    const [start, end] = values.date_range || [];
    if (start && end) {
      const startDate = moment(start).startOf('day');
      const endDate = moment(end).endOf('day');

      const filteredData = newAllAttendance.data.totalAttendanceByUserDay.flatMap(
        (attendanceDay, index) =>
          attendanceDay.attendanceRecords.filter((record) => {
            const recordDate = moment(record.date);
            return recordDate.isBetween(startDate, endDate, null, '[]');
          }).map((record, recordIndex) => ({
            key: `${index}-${recordIndex}`,
            sno: recordIndex + 1,
            date: record.date,
            punchIn: record.punchInTime
              ? moment(record.punchInTime).format('YYYY-MM-DD HH:mm:ss')
              : moment(record.punchOutTime).format('YYYY-MM-DD HH:mm:ss'),
            type: record.type === 'PunchIn' ? 'Punch In' : 'Punch Out',
            production_hour: `${attendanceDay.totalWorkingHours.hours}h ${attendanceDay.totalWorkingHours.minutes}m ${attendanceDay.totalWorkingHours.seconds}s`,
            device_info: record.device_info || "",
            action: "",
          }))
      );
      setAttendanceData(filteredData);
    }
  };

  const handleClear = () => {
    form.resetFields();
    setDateRange([null, null]);
    setAttendanceData(processData(newAllAttendance));
  };

  const processData = (data) => {
    if (!data || !data.data || !data.data.totalAttendanceByUserDay) {
      return [];
    }

    const globalData = {
      punchIn: null,
      punchOut: null,
      userInfo: {},
    };

    const processedData = data.data.totalAttendanceByUserDay.flatMap(
      (attendanceDay, index) =>
        attendanceDay.attendanceRecords.map((record, recordIndex) => {
          if (record.type === "PunchIn") {
            globalData.punchIn = moment(record.punchInTime).format('YYYY-MM-DD HH:mm:ss');
          } else if (record.type === "PunchOut") {
            globalData.punchOut = moment(record.punchOutTime).format('YYYY-MM-DD HH:mm:ss');
          }

          globalData.userInfo = {
            userId: record.user_id._id,
            userName: record.user_id.name,
            punchIn: moment(record.punchInTime).format('YYYY-MM-DD HH:mm:ss'),
            punchOut: moment(record.punchOutTime).format('YYYY-MM-DD HH:mm:ss'),
            deviceInfo: record.device_info,
            IP: record.IP,
          };

          return {
            key: `${index}-${recordIndex}`,
            sno: recordIndex + 1,
            date: record.date,
            punchIn: record.punchInTime
              ? moment(record.punchInTime).format('YYYY-MM-DD HH:mm:ss')
              : moment(record.punchOutTime).format('YYYY-MM-DD HH:mm:ss'),
            type: record.type === 'PunchIn' ? 'Punch In' : 'Punch Out',
            production_hour: `${attendanceDay.totalWorkingHours.hours}h ${attendanceDay.totalWorkingHours.minutes}m ${attendanceDay.totalWorkingHours.seconds}s`,
            device_info: record.device_info || "",
            action: "",
          };
        })
    );

    setUserInfo(globalData.userInfo);
    return processedData;
  };

  useEffect(() => {
    if (newAllAttendance) {
      setAttendanceData(processData(newAllAttendance));
    }
  }, [newAllAttendance]);

  const prepareCsvData = (data) => {
    return data.map((item) => ({
      ...item,
      type: item.type === 'Punch In' ? 'Punch In' : 'Punch Out',
      production_hour: item.production_hour,
    }));
  };

  const csvHeaders = [
    { label: "S. No", key: "sno" },
    { label: "Date", key: "date" },
    { label: "Punch In", key: "punchIn" },
    { label: "Type", key: "type" },
    { label: "Production hour", key: "production_hour" },
    { label: "Device Info", key: "device_info" },
  ];

  return (
    <Layout>
      <Layout style={{ padding: "0 24px 24px" }}>
        <h3 className="mb-4 title">Attendance Details</h3>      
        <Content
          className="site-layout-background"
          style={{
            padding: 14,
            margin: 0,
            minHeight: 280,
          }}
        >
         <Button type="default" onClick={goBack}>
                      <BiArrowBack /> Back
                    </Button>
          <Row gutter={16} style={{ marginTop: 12 }}>
            <Col span={24}>
              <Card title="Search Attendance" bordered={false}>
                <Form form={form} layout="inline" onFinish={handleSubmit}>
                  <Form.Item name="date_range" label="Select Date Range">
                    <DatePicker.RangePicker style={{ marginRight: 10 }} />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Search
                    </Button>
                  </Form.Item>

                  <Form.Item>
                    <Button type="default" onClick={handleClear}>
                      Clear
                    </Button>
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      onClick={() => openModal(getCustomerId)}
                    >
                      View Profile  <FaEye />
                    </Button>
                  </Form.Item>


                  
                </Form>
              </Card>
            </Col>
          </Row>
          <CustomerPopupModal
            open={opens}
            hideModal={closeModal}
            user_info={vclistState}
            user_id={customerId}
          />
          <Row gutter={16} style={{ marginTop: 24 }}>
            <Col span={24}>
              <Card title="Full Attendance" bordered={true}>
                <CSVLink data={prepareCsvData(attendanceData)} headers={csvHeaders} filename={`attendance_${new Date().toISOString()}.csv`}>
                  <Button type="primary" style={{ marginBottom: 16 }}>
                    <ExportOutlined /> Export to CSV
                  </Button>
                </CSVLink>
                <Table
                  columns={columns}
                  className="custom-table"
                  dataSource={attendanceData}
                  pagination={false}
                />
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Attendance;
